import { JSX, useEffect, useState } from 'react';
import { Accept, DropEvent, FileRejection, useDropzone } from 'react-dropzone';
import { useSelector } from 'react-redux';

const FileInputWithDragAndDrop = ({
  placeholder = "Pick file",
  onDrop = () => null,
  className = '',
  // if accept not passed accepts all file types
  accept = undefined,
  multiple = false,
  onDropRejected = () => null,
  onDropAccepted = () => null,
  /// default filesize limit = 12mb
  maxSize = 12000000,
  children,
} : {
  placeholder?: string
  accept?: Accept,
  multiple?: boolean;
  className?: string;
  maxSize?: number;
  onDrop?: <T extends File>(
    acceptedFiles: T[],
    fileRejections: FileRejection[],
    event: DropEvent
  ) => void;
  onDropAccepted: <T extends File>(files: T[], event: DropEvent) => void;
  onDropRejected: (fileRejections: FileRejection[], event: DropEvent) => void;
  children: (isDragActive: boolean) => JSX.Element;
} ) => {

  const {
    getRootProps,
    getInputProps,
    isDragActive,
  } = useDropzone({
    accept: accept,
    multiple: multiple,
    onDrop: onDrop,
    onDropAccepted: onDropAccepted,
    onDropRejected,
    maxSize: maxSize,
  });

  const [showHighlight, setShowHighlight] = useState(false);
  const selectedForm = useSelector((state: any) => state.tax.selectedFormIndex);

  useEffect(() => {
    if (selectedForm === -1) {
      setShowHighlight(true);
      setTimeout(() => {
        setShowHighlight(false);
      }, 1000);
    } else {
      setShowHighlight(false);
    }
  }, [selectedForm]);

  return (
    <div {...getRootProps({
      className: `customFileDropZone ${className}`,
      role: 'button',
      "aria-label": placeholder,
    })}>
      <input {...getInputProps()} aria-hidden />
      {children(isDragActive)}
      <div className={'animatedHighlight ' + (showHighlight ? 'active' : '')} />
    </div>
  );
};

export default FileInputWithDragAndDrop;
